import {
  Component,
  Inject,
  InjectionToken,
  Input,
  OnInit,
} from "@angular/core";
import { StateService, UIRouterGlobals } from "@uirouter/core";
import { EventService } from "../event-service/event.service";
import { RememberService } from "../remember/remember.service";

export const LOCATION_TOKEN = new InjectionToken<Location>("Window location");

@Component({
  providers: [
    // Use our own provider for window.location to make it mockable in specs
    { provide: LOCATION_TOKEN, useValue: window.location },
  ],
  templateUrl: "./project-picker.component.html",
})
export class ProjectPickerComponent implements OnInit {
  @Input() public projects: any;
  @Input() public project: any;
  @Input() public user: any;
  @Input() public closeMenu: any;
  public selectOpen: boolean;
  public selectedProjectId: number;
  private REMEMBER_KEY = "projects.lastViewed";

  constructor(
    @Inject(LOCATION_TOKEN) private location: Location,
    private $state: StateService,
    private $uiRouterGlobals: UIRouterGlobals,
    private eventService: EventService,
    private rememberService: RememberService,
  ) {}

  public select(newProject: any) {
    if (newProject == null) {
      return;
    }

    let state = "";

    if (this.$uiRouterGlobals.current.name === "project-deploys") {
      state = "project-deploys";
    } else if (this.$uiRouterGlobals.current.name === "project-performance") {
      state = "project-performance";
    } else if (this.$uiRouterGlobals.current.name === "project-alerts") {
      state = "project-alerts";
    } else if (this.$uiRouterGlobals.current.name === "project-trends") {
      state = "project-trends";
    } else {
      state = "project-errors";
    }

    this.$state.go(state, { projectId: newProject.id }, { inherit: false });

    this.rememberService.set(this.REMEMBER_KEY, newProject.id);
  }

  public ngOnInit() {
    this.projects = this.projects || [];

    // Handle (the rare) case of a user with no project memberships.
    if (this.projects.length < 1) {
      this.location.replace(`/users/${this.user.id}/edit`);
      return;
    }

    if (this.project != null) {
      this.rememberService.set(this.REMEMBER_KEY, this.project.id);
      this.selectedProjectId = this.project.id;

      if (!this.projects.some((p: any) => p.id === this.project.id)) {
        this.projects.push(this.project);
      }
    }

    window.document.title =
      this.project != null ? this.project.name : "Account Dashboard";

    this.eventService.publish("show-install-airbrake-btn", false);
  }
}
